import * as React from 'react';
import * as firebase from 'firebase' ;
import { MyAccountMenu } from './MyAccountMenu';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { SecurityData } from '../shared/index';

export interface AccountLeftSideProps extends BaseComponentProps {
  lang: string ;  
	user: SecurityData.ApplicationUser ; 
  user_login: boolean ;    
  hengleUserDialogClose: () => any;
  userAccess: string;
  firebaseApp: firebase.app.App ; 
} 
export interface AccountLeftSideState extends BaseComponentState {}
export class AccountLeftSide extends BaseComponent<AccountLeftSideProps , AccountLeftSideState> {

	constructor(props: AccountLeftSideProps) {
		super(props);
  }  

  render() {
    if ( this.state.haveReactError ) {
      return this.renderErrorPanel() ; 
  } 
    return (
      <div className="col-md-3">
          <MyAccountMenu  
            firebaseApp={this.props.firebaseApp}
            lang={this.props.lang} 
            user={this.props.user} 
            user_login={this.props.user_login} 
            hengleUserDialogClose={this.props.hengleUserDialogClose}  
            userAccess={this.props.userAccess}
          /> 
      </div>
        
    );
  }
} 
 


// WEBPACK FOOTER //
// ./src/my-account/AccountLeftSide.tsx